module.exports = __webpack_public_path__ + "static/img/1.abfa3fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/User/1.png
// module id = O0PE
// module chunks = 0